import React from 'react';
function Attributes() {
  return (
    <svg width='28' height='28' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='8' fill='#8CCC43' />
      <path
        d='M12.4003 11.2H19.6003M12.4003 14.8H19.6003M12.4003 18.4H16.0003M10.6 6.40002H21.4003C22.7258 6.40002 23.8003 7.47457 23.8003 8.80007L23.8 23.2001C23.8 24.5255 22.7254 25.6 21.4 25.6L10.5999 25.6C9.27446 25.6 8.19994 24.5254 8.19995 23.2L8.20004 8.80001C8.20005 7.47453 9.27457 6.40002 10.6 6.40002Z'
        stroke='white'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default Attributes;
